import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData } from '../../apiService';
import { Card, CardContent, Button } from '@mui/material';
import Refresh from '@mui/icons-material/Refresh';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CachedIcon from '@mui/icons-material/Cached';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InventoryIcon from '@mui/icons-material/Inventory';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import Select from 'react-select';
import './Home.css'; // Import your CSS file
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CopyrightIcon from '@mui/icons-material/Copyright';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import BuildIcon from '@mui/icons-material/Build';
import {
  Delete as DeleteIcon, Edit as EditIcon, ArrowForward,
  CheckCircle as ActivateIcon, Search as SearchIcon,
  Print as PrintIcon, Info as InfoIcon
} from '@mui/icons-material';
import AsyncSelect from 'react-select/async';

import {
  IconButton
} from '@mui/material';

const Home = () => {
  const { isAuthenticated, companyId, branchId, permissions, token, logout, roleName } = useAuth();
  const { id } = useParams();
  const history = useHistory();
  const [stockData, setStockData] = useState([]);
  const [penstockData, setPenStockData] = useState([]);
  const [penstockPendingData, setPenStockPendingData] = useState([]);
  const [itemId, setItem] = useState('');
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [showTable, setShowTable] = useState(false);

  const handleStockCheck = () => {
    setShowTable(!showTable);
    setStockData([]); // Clear stockData    
    setSelectedItems(null); // Reset selectedItems
    setSelectedOption(null); // Clear AsyncSelect
    fetchOptions('');
  };

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }
  }, [isAuthenticated, companyId, branchId, token, logout, id]);

  // Items    
  const [itemsOptions, setItemsOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState("");

  useEffect(() => {
    //fetchItems();
  }, []);

  const fetchOptions = async (inputValue) => {
    if (inputValue.length <= 1) {
      return [];
    }

    const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);
    if (response.responseCode === '1111') {
      const data = await response.response_data;
      return data.map(item => ({
        value: item.Id,
        label: item.Code + '-' + item.ItemName,
      }));
    }
  };

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await fetchData('ReportApi', `/Stockin/${companyId}/${branchId}`, token);
        if (response.responseCode === '1111') {
          setPenStockData(response.response_data);
        }
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };

    fetchStockData();
  }, [companyId, branchId, token]);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await fetchData('ReportApi', `/Stockinpend/${companyId}/${branchId}`, token);
        if (response.responseCode === '1111') {
          setPenStockPendingData(response.response_data);
        }
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };

    fetchStockData();
  }, [companyId, branchId, token]);

  const fetchItems = async () => {
    try {
      const response = await fetchData('ReportApi', `/Item/${companyId}/${branchId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(item => ({
          value: item.Id,
          label: item.Code + '-' + item.Name
        }));
        setItemsOptions(options);
      }
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const handleItemSelect = (selectedOption) => {
    setSelectedItems(selectedOption);
    const itId = selectedOption ? selectedOption.value : '';
    setItem(itId);
  };

  const handleChangeDrop = (selectedOption) => {
    setSelectedOption(selectedOption);
    const itId = selectedOption ? selectedOption.value : '';
    setItem(itId);
  };

  const handleRefresh = async () => {
    try {
      if (!itemId) {
        setError("Please select an item.");
        return;
      } else {
        const response = await fetchData('ReportApi', `/BranchStock/${companyId}/${itemId}`, token);
        if (response.responseCode === '1111') {
          const stockData = response.response_data;
          setStockData(stockData);

          // Calculate total quantity
          const total = stockData.reduce((sum, invdetail) => sum + invdetail.ClosingQty, 0);
          setTotalQuantity(total);
        }
      }
    } catch (error) {
      console.error('Error fetching stock data:', error);
    }
  };

  function formatDate(dateString) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
    return formattedDate;
  }

  const [selectedOption, setSelectedOption] = useState(null);
  const handleInputChange = (newValue) => newValue;
  const allowedBranchIds = [2, 1004, 1010];

  return (
    <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>
      <style>
        {`
        /* Hide scrollbar for Chrome, Safari, and Opera */
        .container::-webkit-scrollbar {
          width: 0.1em;
        }

        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }

        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
      </style>
      <div className="flex flex-wrap justify-between">

        <div className="w-full sm:w-4/4 mb-4 ">
          <CardContent>
            <div className="flex justify-between items-center">
              <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor animated-title" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}></h4>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                {/* Stock Check Button */}
                <Button
                  className="bg-teal-600 text-black px-3 py-1 rounded-md text-sm hover:bg-teal-700"
                  onClick={handleStockCheck}
                  style={{ background: 'linear-gradient(to right, #C7D9DD, #C7D9DD)', color: 'white', height: '26px', marginRight: '8px', borderRadius: '25px', fontFamily: 'monospace' }}
                >
                  <VisibilityIcon style={{ fontSize: '15px', marginRight: '5px' }} /> Stock Check
                </Button>

                {/* Role-Based Buttons */}
                {roleName !== "Accounts" && (
                  <>
                    <Button
                      className="bg-blue-600 text-black px-3 py-1 rounded-md text-sm hover:bg-blue-700"
                      component={Link}
                      to="/NewSaleCreate"
                      style={{ background: 'linear-gradient(to right, #D4F6FF, #D4F6FF)', color: 'black', height: '26px', marginRight: '8px', borderRadius: '25px', fontFamily: 'monospace' }}
                    >
                      <ShoppingCartIcon style={{ fontSize: '15px', marginRight: '5px' }} />Sale
                    </Button>

                    <Button
                      className="bg-red-600 text-black px-3 py-1 rounded-md text-sm hover:bg-red-700"
                      component={Link}
                      to="/NewPurchaseCreate"
                      style={{ background: 'linear-gradient(to right, #E9EED9, #E9EED9)', color: 'white', height: '26px', marginRight: '8px', borderRadius: '25px', fontFamily: 'monospace' }}
                    >
                      <AddShoppingCartIcon style={{ fontSize: '15px', marginRight: '5px' }} /> Purchase
                    </Button>

                    <Button
                      className="bg-yellow-600 text-black px-3 py-1 rounded-md text-sm hover:bg-yellow-700"
                      component={Link}
                      to="/Stock"
                      style={{ background: 'linear-gradient(to right, #EEEEEE, #EEEEEE)', color: 'white', height: '26px', marginRight: '8px', borderRadius: '25px', fontFamily: 'monospace' }}
                    >
                      <InventoryIcon style={{ fontSize: '15px', marginRight: '5px' }} />Stock
                    </Button>

                    <Button
                      className="bg-gray-600 text-black px-3 py-1 rounded-md text-sm hover:bg-gray-700"
                      component={Link}
                      to="/DailySalesSummary"
                      style={{ background: 'linear-gradient(to right, #FBE4D6, #FBE4D6)', color: 'white', height: '26px', marginRight: '8px', borderRadius: '25px', fontFamily: 'monospace' }}
                    >
                      <AssessmentIcon style={{ fontSize: '15px', marginRight: '5px' }} /> DSS
                    </Button>
                  </>
                )}
              </div>

            </div>

            {showTable && (
              <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div className="w-full mb-4 flex">
                  <div className="w-3/7 mr-3" style={{ marginLeft: '5px', width: '500px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                      Item Name
                      <span className="text-red-500">*</span>
                    </label>
                    <AsyncSelect
                      cacheOptions
                      loadOptions={fetchOptions}
                      onInputChange={handleInputChange}
                      onChange={handleChangeDrop}
                      value={selectedOption}
                    />
                  </div>
                  <div className="w-1/2 mr-4">
                    <Button onClick={handleRefresh} startIcon={<Refresh style={{ color: 'brown' }} />} style={{ marginTop: '25px', marginLeft: '12px', color: 'brown', fontWeight: 'bolder' }}>REFRESH</Button>
                  </div>
                </div>

                <div className="w-full mb-2 flex">

                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead sx={{ backgroundColor: '#008080' }}>
                        <TableRow>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke' }}>BRANCH NAME</TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '12px', padding: '2px', color: 'whitesmoke', textAlign: 'right' }}>QUANTITY</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ backgroundColor: '#9BC1B3' }}>

                        {stockData.map((item, index) => (
                          <TableRow
                            className={'highlighted-row'}
                            sx={{
                              padding: '5px',
                              height: '30px',

                              backgroundColor: 'transparent',

                            }}
                          >
                            <TableCell sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px', width: '75%' }}>{item.BranchName}</TableCell>
                            <TableCell sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{item.ClosingQty.toFixed(2)}</TableCell>
                          </TableRow>
                        ))}

                        <TableRow
                          className={'highlighted-row'}
                          sx={{
                            padding: '7px',
                            height: '30px',

                            backgroundColor: '#507687',

                          }}
                        >
                          <TableCell sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px', textAlign: 'Left', fontSize: '12px' }}>Total</TableCell>
                          <TableCell sx={{ height: '30px', borderBottom: '1px solid #F5F5F5', color: 'white', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{totalQuantity.toFixed(2)}</TableCell>
                        </TableRow>
                      </TableBody>


                    </Table>
                  </TableContainer>
                </div>
              </div>
            )}

          </CardContent>
        </div>

        {/* {roleName != "Accounts" && (
          <div className="w-full sm:w-4/4 mb-4 ">
            <CardContent>
              <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'monospace', fontWeight: 'bolder' }}>CONFIRM STOCK TRANSFER IN</h6>
              </div>

              <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#008080' }}>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', fontFamily: 'monospace' }}>BILL DATE</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', fontFamily: 'monospace' }}>BILL NUMBER</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '40%', fontFamily: 'monospace' }}>FROM BRANCH</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center', fontFamily: 'monospace' }}>AMOUNT</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center', fontFamily: 'monospace' }}>QUANTITY</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', textAlign: 'center', fontFamily: 'monospace' }}>ACTIONS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{ backgroundColor: '#9BC1B3' }}>
                      {penstockData.map(item => (
                        <TableRow
                          key={item.id}
                          className={item.IsActive ? '' : 'inactiveRow'}
                          style={{ backgroundColor: item.InputAccepted ? '#d4edda' : '#f8d7da' }}
                        >
                          <TableCell sx={{ padding: '2px', width: '10%' }}>{formatDate(item.BillDate)}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '10%' }}>{item.BillPrefix}/S/{item.BillNumber}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '40%' }}>{item.ToBranchName}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.GrandTotal}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.TotalQuantity}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '10%', textAlign: 'right' }}>
                            <IconButton component={Link} to={`/StockInDetail/${item.Id}`}>
                              <InfoIcon style={{ fontSize: '20px', color: 'goldenrod' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>
              </div>
            </CardContent>
          </div>
        )}

        {roleName != "Accounts" && (
          <div className="w-full sm:w-4/4 mb-4 ">
            <CardContent>
              <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'monospace', fontWeight: 'bolder' }}>STOCK TRANSFER APPROVAL PENDING</h6>
              </div>

              <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#008080' }}>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', fontFamily: 'monospace' }}>BILL DATE</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', fontFamily: 'monospace' }}>BILL NUMBER</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '40%', fontFamily: 'monospace' }}>TO BRANCH</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center', fontFamily: 'monospace' }}>AMOUNT</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', width: '10%', textAlign: 'center', fontFamily: 'monospace' }}>QUANTITY</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '2px', color: 'whitesmoke', textAlign: 'center', fontFamily: 'monospace' }}>ACTIONS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody style={{ backgroundColor: '#9BC1B3' }}>
                      {penstockPendingData.map(item => (
                        <TableRow
                          key={item.id}
                          className={item.IsActive ? '' : 'inactiveRow'}
                          style={{ backgroundColor: item.InputAccepted ? '#d4edda' : '#f8d7da' }}
                        >
                          <TableCell sx={{ padding: '2px', width: '10%' }}>{formatDate(item.BillDate)}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '10%' }}>{item.BillPrefix}/S/{item.BillNumber}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '40%' }}>{item.ToBranchName}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.GrandTotal}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '15%', textAlign: 'center' }}>{item.TotalQuantity}</TableCell>
                          <TableCell sx={{ padding: '2px', width: '10%', textAlign: 'right' }}>
                            <IconButton component={Link} to={`/StockInPending/${item.Id}`} color="primary">
                              <InfoIcon style={{ fontSize: '20px', color: 'goldenrod' }} />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>

                  </Table>
                </TableContainer>
              </div>
            </CardContent>
          </div>
        )} */}
      </div>
      <div className="watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>
  );
};

export default Home;
